import { createRoot } from 'react-dom/client'
import AccessibilityTest from './components/AccessibilityTest';
import 'bootstrap/js/dist/modal'

// const domNode = document.getElementById('accessibility-test')
// if (domNode) {
//   const root = createRoot(domNode)
//   root.render(<AccessibilityTest wave_api_key={process.env.MIX_WAVE_API_KEY} />)
// }

document.querySelectorAll('.accessibility-test').forEach((el, idx) => {
  const waveKey = el.dataset.waveApiKey || process.env.MIX_WAVE_API_KEY
  const root = createRoot(el)
  root.render(
    <AccessibilityTest
      wave_api_key={waveKey}
    />
  )
})

// window.addEventListener('load', () => {
//   if (typeof Calendly != "undefined") {
//     Calendly.initInlineWidget({
//       url: 'https://calendly.com/marketingwizard/30min?hide_event_type_details=1&hide_gdpr_banner=1&text_color=0B2B51&primary_color=0B2B51',
//       parentElement: document.getElementById('calendly-embed'),
//       // text: 'Get a Free Consultation',
//       // color: '#0B2B51',
//       resize: true,
//       // textColor: '#0B2B51',
//       // // branding: true,
//       // primary_color: "#214475"
//     });
//   }
// })